import type { ComponentProps, ReactNode } from "react";

import { AppNavColumn } from "./app-nav-column";
import { AppNavProvider, type AppNavProviderProps } from "./app-nav-provider";

export interface AppNavProps extends AppNavProviderProps, ComponentProps<typeof AppNavColumn> {
  children: ReactNode;
}

export const AppNav = ({ children, side, isCollapsed, setIsCollapsed, ...props }: AppNavProps) => (
  <AppNavProvider side={side} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed}>
    <AppNavColumn {...props}>{children}</AppNavColumn>
  </AppNavProvider>
);
